import { render } from "./NewsDetail.vue?vue&type=template&id=6c16a35e&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=6c16a35e&scoped=true&lang=css"

import exportComponent from "E:\\ismailDosyalar\\gifSites2\\gifSites\\2022\\gesas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c16a35e"]])

export default __exports__